export const colors = {
  brand10: '#9b4dee',
  brand20: '#e0457b',
  brand30: '#f7ea48',
  brandDark: '#6700a2',
  brandLight: '#d8b8f9',
  brandGreen: '#4ba047',
  brandGreenTransparent: '#4ba04765',

  lightPurple10: '#e6d7fb',

  default10: '#f1f1f1',
  default20: '#e1e6eb',
  default30: '#d1d8dc',

  gray10: '#acacac',
  gray20: '#707070',
  gray30: '#dfdfdf',
  gray40: '#dcdcdc',
  gray50: '#f9f9f9',
  gray60: '#d6d6d6',
  gray70: '#f2f2f2',
  gray80: '#f7f7f7',
  gray90: '#efefef',

  grayBorderLight: '#E5E7EB',

  anotherGray10: '#d9d9d9',
  anotherGray20: '#525252',

  text20: '#242424',

  sutil: '#fefefe',
  white: '#ffffff',
  black: '#000000',

  transparent: 'rgba(0, 0, 0, 0)',
  hover: 'rgba(211, 211, 211, 0.4)',

  highlight: '#ff0000',

  success10: '#e8f5e9',
  success20: '#43a047',
  success30: '#1b5e20',

  card: '#eeeeee',

  successLight: '#5bcc5f',

  warning10: '#fff3e0',
  warning20: '#fb8c00',
  warning30: '#e65100',

  gold: '#febf00',

  danger10: '#ffebee',
  danger20: '#e53935',
  danger30: '#b71c1c',
  danger40: '#C30A04',
  danger50: '#FB3730',

  info10: '#e3f2fd',
  info20: '#1e88e5',
  info30: '#0d47a1',
  info40: '#105BFB',

  brandTransparent: 'rgba(155, 77, 238, 0.9)',

  background: 'rgba(0, 0, 0, 0.4)',

  orange10: '#D3800D',
};
